import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { LogsView } from "@/components/system-logs/LogsView";

export function LogsPage() {
  return (
    <PageContainer>
      <PageHeader
        eyebrow="System"
        title="Logs"
        description="Server errors and API interactions — filter, search, and drill into any entry."
      />

      <LogsView />
    </PageContainer>
  );
}
